module.exports = __webpack_public_path__ + "media/order_ringtone.e1b7e041.ogg";